import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

import ContentContainer from '../ContentContainer';

let styles;
const SEVENSHARP_LOGO = require('./brands/7sharp.png');
const TVNZ_LOGO = require('./brands/tvnz.png');
const ONENEWS_LOGO = require('./brands/1news.png');
const STUFF_LOGO = require('./brands/stuff.png');

export default () => (
  <div className={css(styles.container)}>
    <ContentContainer>
      <h2 className={css(styles.heading)}>As Seen On</h2>
      <div className={css(styles.brands)}>
        <div className={css(styles.brand)}>
          <img src={ONENEWS_LOGO} alt="One News Now" className={css(styles.onenews)} />
        </div>
        <div className={css(styles.brand)}>
          <img src={TVNZ_LOGO} alt="TVNZ" className={css(styles.tvnz)} />
        </div>
        <div className={css(styles.brand)}>
          <img src={SEVENSHARP_LOGO} alt="Seven Sharp" className={css(styles.sevensharp)} />
        </div>
        <div className={css(styles.brand)}>
          <img src={STUFF_LOGO} alt="Stuff" className={css(styles.stuff)} />
        </div>
      </div>
    </ContentContainer>
  </div>
);

styles = StyleSheet.create({
  container: {
    padding: '35px 0',
    textAlign: 'center',
    backgroundColor: Theme.white,

    [Theme.mobile_query]: {
      padding: '45px 0 35px',
    },
  },
  heading: {
    marginBottom: 35,
    fontFamily: Theme.font_family_secondary,
    fontSize: 15,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontWeight: Theme.font_weight_heading,
    lineHeight: 1.73,
    color: '#000e1f',
  },
  brands: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 920,
    margin: '0 auto 46px',

    [Theme.mobile_query]: {
      width: 'auto',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  brand: {
    margin: '0 60px',

    [Theme.mobile_query]: {
      margin: 0,
      padding: '15px 30px',
    },
  },
  onenews: {
    maxWidth: 181,
    maxHeight: 37,
  },
  tvnz: {
    maxWidth: 86,
    maxHeight: 107,
  },
  sevensharp: {
    maxWidth: 89,
    maxHeight: 75,
  },
  stuff: {
    maxWidth: 88,
    maxHeight: 72,
  },
});



// WEBPACK FOOTER //
// ./src/components/AsSeenOnTV/index.js